export default {
  "agentCashbackAdmin.title": "代理返现管理",
  "agentCashbackAdmin.thead.index": "#No",
  "agentCashbackAdmin.thead.id": "ID",
  "agentCashbackAdmin.thead.gameType": "游戏类型",
  "agentCashbackAdmin.thead.inviteUserNum": "邀请用户数",
  "agentCashbackAdmin.thead.betAmount": "投注金额",
  "agentCashbackAdmin.thead.bonus": "奖励",
  "agentCashbackAdmin.thead.withdrawLimitRatio": "流水倍率",
  "agentCashbackAdmin.thead.createTime": "创建时间",
  "agentCashbackAdmin.thead.modifyTime": "修改时间",
  "agentCashbackAdmin.thead.operator": "操作人",

  "agentCashbackAdmin.thead.action": "操作",
  "agentCashbackAdmin.add": "新增",
  "agentCashbackAdmin.edit": "编辑",
  "agentCashbackAdmin.details": "详情",
  "agentCashbackAdmin.delete": "删除",
};
